var ruPlural = (function (count, params) {
    var lastNumber = count % 10;
    var lastNumbers = count % 100;
    if (!count) {
        return params.none || '';
    }
    if (lastNumber === 1 && lastNumbers !== 11) {
        return params.one;
    }
    if (lastNumber >= 2 &&
        lastNumber <= 4 &&
        lastNumbers !== 12 &&
        lastNumbers !== 13 &&
        lastNumbers !== 14) {
        return params.some;
    }
    return params.many || '';
});

var enPlural = (function (count, params) {
    if (!count) {
        return params.none || '';
    }
    if (count === 1) {
        return params.one;
    }
    return params.some;
});

var idPlural = (function (count, params) {
    if (!count) {
        return params.none || '';
    }
    return params.some;
});

var kkPlural = (function (count, params) {
    var lastNumber = count % 10;
    var lastNumbers = count % 100;
    if (!count) {
        return params.none || '';
    }
    if (lastNumber === 1 && lastNumbers !== 11) {
        return params.one;
    }
    if ((lastNumber > 1 && lastNumber < 5) && (lastNumbers < 10 || lastNumbers > 20)) {
        return params.some;
    }
    return params.many || '';
});

var trPlural = (function (count, params) {
    var lastNumber = count % 10;
    var lastNumbers = count % 100;
    if (!count) {
        return params.none || '';
    }
    if (lastNumber === 1 && lastNumbers !== 11) {
        return params.one;
    }
    if ((lastNumber > 1 && lastNumber < 5) && (lastNumbers < 10 || lastNumbers > 20)) {
        return params.some;
    }
    return params.many || '';
});

var ttPlural = (function (count, params) {
    var lastNumber = count % 10;
    var lastNumbers = count % 100;
    if (!count) {
        return params.none || '';
    }
    if (lastNumber === 1 && lastNumbers !== 11) {
        return params.one;
    }
    if ((lastNumber > 1 && lastNumber < 5) && (lastNumbers < 10 || lastNumbers > 20)) {
        return params.some;
    }
    return params.many || '';
});

var uzPlural = (function (count, params) {
    var lastNumber = count % 10;
    var lastNumbers = count % 100;
    if (!count) {
        return params.none || '';
    }
    if (lastNumber === 1 && lastNumbers !== 11) {
        return params.one;
    }
    if ((lastNumber > 1 && lastNumber < 5) && (lastNumbers < 10 || lastNumbers > 20)) {
        return params.some;
    }
    return params.many || '';
});

var amPlural = (function (count, params) {
    if (!count || count === 1) {
        return params.one;
    }
    return params.many || '';
});

var viPlural = (function (count, params) {
    if (count === 1) {
        return params.one;
    }
    return params.many || '';
});

var pluralMap = {
    be: ruPlural,
    en: enPlural,
    id: idPlural,
    kk: kkPlural,
    ru: ruPlural,
    tr: trPlural,
    tt: ttPlural,
    uk: ruPlural,
    uz: uzPlural,
    de: enPlural,
    es: enPlural,
    hy: enPlural,
    ka: enPlural,
    ky: ruPlural,
    sr: ruPlural,
    fr: ruPlural,
    lv: ruPlural,
    lt: ruPlural,
    ro: ruPlural,
    fi: enPlural,
    az: enPlural,
    zh: enPlural,
    he: enPlural,
    et: enPlural,
    no: idPlural,
    sv: idPlural,
    pt: enPlural,
    'pt-br': enPlural,
    ar: enPlural,
    sw: enPlural,
    ur: enPlural,
    am: amPlural,
    vi: viPlural
};
var _langs = ['ru'];
function generateText(template, options) {
    var res = [];
    var len = template.length;
    var pos = 0;
    while (pos < len) {
        var p1 = template.indexOf('{', pos);
        if (p1 === -1) {
            res.push(template.substring(pos));
            return res;
        }
        var p2 = template.indexOf('}', p1);
        if (p2 === -1) {
            res.push(template.substring(pos));
            return res;
        }
        res.push(template.substring(pos, p1), options[template.substring(p1 + 1, p2)]);
        pos = p2 + 1;
    }
    return res;
}
function generateTextWithPlural(plural, options) {
    var lang = _langs.find(function (lang) { return Boolean(pluralMap[lang]); }) || getDefLang(_langs[0]);
    var pluralizer = pluralMap[lang];
    var template = pluralizer(options.count, plural);
    return generateText(template, options);
}
function tr(dictionary, key) {
    var keyset;
    for (var _i = 0, _langs_1 = _langs; _i < _langs_1.length; _i++) {
        var lang = _langs_1[_i];
        keyset = dictionary[lang];
        if (keyset && key in keyset)
            return keyset[key];
    }
    return key;
}
function _i18n(dictionary, key, options) {
    if (options === void 0) { options = {}; }
    var translation = tr(dictionary, key);
    if (typeof translation === 'string') {
        return generateText(translation, options);
    }
    return generateTextWithPlural(translation, options);
}
function i18n(keyset) {
    return function (key, options) {
        if (options === void 0) { options = {}; }
        return _i18n(keyset, key, options).join('');
    };
}
function i18nRaw(keyset) {
    return function (key, options) {
        if (options === void 0) { options = {}; }
        return _i18n(keyset, key, options);
    };
}
function getDefLang(lang) {
    return ['tr', 'id', 'fi', 'lt', 'pl', 'et', 'lv'].indexOf(lang) === -1 ? 'ru' : 'en';
}
function setI18nLang(lang) {
    _langs = typeof lang === 'string' ? [lang, getDefLang(lang), 'ru'] : lang;
}
function getI18nLang() {
    return _langs[0];
}
function getI18nLangs() {
    return _langs;
}
function resolveI18nLang(languages, requestLang, requestTld) {
    var language = requestLang;
    if (languages.indexOf(language) === -1) {
        switch (requestTld) {
            case 'com':
                language = 'en';
                break;
            case 'com.tr':
                language = 'tr';
                break;
            default:
                language = 'ru';
        }
    }
    return language;
}

export { i18n as default, getDefLang, getI18nLang, getI18nLangs, i18nRaw, resolveI18nLang, setI18nLang };
